import * as yup from 'yup'
import { IntlShape, defineMessages } from 'react-intl'

const messages = defineMessages({
  required: {
    id: 'trips.createIncidenceModal.form.field.required',
    defaultMessage: 'This field is required'
  }
})

export const schema = (intl: IntlShape): yup.AnySchema => {
  return yup.object().shape({
    authorizer: yup.string().required(intl.formatMessage(messages.required)),
    reason: yup.string().required(intl.formatMessage(messages.required)),
    campaign: yup.object().shape({
      id: yup.string().required(intl.formatMessage(messages.required))
    }),
    trip: yup.object().shape({
      legSegments: yup
        .array()
        .of(
          yup.object().shape({
            id: yup.string().required(intl.formatMessage(messages.required))
          })
        )
        .min(1, intl.formatMessage(messages.required))
    })
  })
}
